// extracted by mini-css-extract-plugin
module.exports = {"main":"accordion_main__1L8ak","details":"accordion_details__jKUCX","summary":"accordion_summary__QKjMl","sweep":"accordion_sweep__qMJGN"};